import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import { connect } from '../../connect';
import { requestForgotPassword } from '../../actions';
import '../../styles/sign-in-register.less';
import { IAuthState } from '../../reducers/auth-reducers';
import { IForgotPasswordState } from '../../reducers/accounts-reducers';
import { IReduxProps } from '../../actions/action-types';

function mapStateToProps({ auth, forgotPassword }) {
	return { auth, forgotPassword };
}

interface IForgotPasswordPageProps extends IReduxProps {
	auth: IAuthState;
	forgotPassword: IForgotPasswordState;
}

interface IForgotPasswordPageState {
	email: string;
}

@connect(mapStateToProps)
export default class ForgotPasswordPage extends React.Component<IForgotPasswordPageProps, IForgotPasswordPageState> {
	private emailInput?: HTMLInputElement | null;

	state: IForgotPasswordPageState = {
		email: '',
	};

	componentDidMount() {
		const el = document.getElementById('app');
		if (el) {
			el.classList.add('ForgotPasswordPage');
		}
		this.focusEmailInput();
	}

	componentWillUnmount() {
		const el = document.getElementById('app');
		if (el) {
			el.classList.remove('ForgotPasswordPage');
		}
	}

	handleSubmit: React.FormEventHandler<HTMLFormElement> = event => {
		const { forgotPassword, dispatch } = this.props;
		event.preventDefault();
		if (!forgotPassword.isProcessing) {
			dispatch(requestForgotPassword(this.state.email));
			this.focusEmailInput();
		}
	};

	handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
		const nextState = {};
		nextState[event.target.name] = event.target.value;
		this.setState(nextState);
	}

	focusEmailInput = () => {
		if (this.emailInput) {
			this.emailInput.focus();
		}
	};

	renderForgotPasswordForm(forgotPassword) {
		return (
			<div>
				<h2 className="centered">Forgot your password?</h2>
				<div>{this.renderForgotPasswordError(forgotPassword)}</div>
				<form method="post" onSubmit={this.handleSubmit}>
					<input
						type="text"
						placeholder="Email"
						name="email"
						ref={ref => (this.emailInput = ref)}
						onChange={e => this.handleInputChange(e)}
					/>
					<button type="submit">Reset Password</button>
				</form>
			</div>
		);
	}

	renderForgotPasswordRequested() {
		return (
			<div className="centered-forgot-password-success-text">
				Please check your email for a message that will help you complete the password reset process.
			</div>
		);
	}

	renderForgotPasswordError(forgotPassword) {
		if (!forgotPassword.error) {
			return null;
		}

		return <div className="centered-error-text">{forgotPassword.error}</div>;
	}

	render() {
		const forgotPassword = this.props.forgotPassword;

		return (
			<div className="forgot-password-page">
				<Helmet title="Forgot Password" />
				<div className="background" />
				<div className="container">
					<div className="centered">
						{forgotPassword && forgotPassword.forgotPasswordRequested
							? this.renderForgotPasswordRequested()
							: this.renderForgotPasswordForm(forgotPassword)}
						<div className="centered-bottom-text">
							<Link to="/signin">Sign In</Link> or <Link to="/register">Register</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
